<template>
  <SoPageWithHeader title="Services">
    <div class="pt-4">
      <SoDataTable
        :headers="headers"
        :items="services"
        :row-clickable="true"
        :searchable="false"
        :has-pagination="false"
        data-testid="services-table"
        @click:row="goToService"
      />
    </div>
  </SoPageWithHeader>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import SoDataTable from "@/components/dataTable/SoDataTable.vue"
  import { SoDataTableHeader } from "@/types/components/SoDataTable"
  import { RouteNames } from "@/types/router"
  import { SERVICES, IService } from "@/views/admin/services/services.constants"

  const headers: SoDataTableHeader[] = [
    { title: "Name", key: "name", sortable: false },
  ]

  export default defineComponent({
    components: {
      SoPageWithHeader,
      SoDataTable,
    },
    data() {
      return {
        headers,
        services: SERVICES,
      }
    },
    methods: {
      goToService(service: IService) {
        this.$router.push({
          name: RouteNames.AdminServiceConfig,
          params: { serviceName: service.slug },
        })
      },
    },
  })
</script>
